import React, {useState, useEffect, useContext, useRef} from 'react'
import {useTranslation} from 'react-i18next'
import {useParams} from 'react-router-dom'
// Firebase
import { FirebaseContext } from "../../../firebase/"
// Redux
import {useDispatch} from "react-redux"
import { PlayNotifications } from 'redux/notifications/PlayNotifications'
import LayoutDashboard from "components/layout/LayoutDashboard";
import {PROJECTS_MENU} from "utils/constantsBackOffice";
import {
  RiAddLine,
  RiArrowLeftLine, RiBarChartBoxLine,
  RiBuildingLine, RiCalendarEventFill,
  RiCodeBoxLine, RiDownload2Line, RiExternalLinkLine, RiEyeLine, RiGoogleFill, RiLayoutLine, RiLayoutTop2Line, RiListOrdered2,
  RiLoader4Line, RiLoginBoxLine, RiPencilLine, RiPencilRulerLine, RiPlayListAddFill, RiRefreshLine,
  RiRobot2Line, RiAiAgentLine,
  RiSearchLine, RiSeoLine, RiSparkling2Line, RiUpload2Line
} from "react-icons/ri";
import Button from "components/elements/button/Button";
import Headings from "components/elements/Typography/Headings";
import _ from "lodash";
import {capitalizeFirstLetter} from "utils/stringUtils";
import moment from "moment/moment";
import ChangePlanForm from "components/modals/ChangePlanForm";
import ChangeModeForm from "components/modals/ChangeModeForm";
import DeployFrontForm from "components/modals/DeployFrontForm";
import CreditsForm from "components/modals/CreditsForm";
import {TbNorthStar} from "react-icons/tb";
import {getLCP} from "web-vitals";

const ProjectPage = ({ selectedMenu, currentUser }) => {
  // Translations
  const { t } = useTranslation(['common', 'messages', 'dashboard']);

  const firebase = useContext(FirebaseContext);
  const dispatch = useDispatch();

  let currentUrl = useParams() // observes a change of url
  const [currentId, ] = useState(currentUrl.id ? currentUrl.id : null);

  const [ready, setReady] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [state, setState] = useState({});
  const [entityRequest, setEntityRequest] = useState(null);
  const [openChangePlan, setOpenChangePlan] = useState(false);
  const [openChangeMode, setOpenChangeMode] = useState(false);
  const [openDeployFront, setOpenDeployFront] = useState(false);
  const [openDeploy, setOpenDeploy] = useState(false);
  const [openDeployTrialEnding, setOpenDeployTrialEnding] = useState(false);
  const [openDeployRestoreFront, setOpenDeployRestoreFront] = useState(false);
  const [openDeploySpecificBackend, setOpenDeploySpecificBackend] = useState(false);
  const [openDeployFullBackend, setOpenDeployFullBackend] = useState(false);
  const [refreshCreditsLoading, setRefreshCreditsLoading] = useState(false);
  const [openCreditsForm, setOpenCreditsForm] = useState(false);
  const [openAddCreditsForm, setOpenAddCreditsForm] = useState(false);
  const [recentBuilds, setRecentBuilds] = useState([]);
  const [buildsLoading, setBuildsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('0');

  const availableOptions = [
    {id: 'agents', name: t('projects.options.Agents'), picto: <RiAiAgentLine className={'w-4 h-4'} />},
    {id: 'api', name: t('projects.options.Api'), picto: <RiCodeBoxLine className={'w-4 h-4'} />},
    {id: 'ai.content_generative_ai', name: t('projects.options.Ai-content-generative-ai'), picto: <RiSparkling2Line className={'w-4 h-4'} />},
    {id: 'ai.prompts_families', name: t('projects.options.Ai-prompts-families'), picto: <RiSparkling2Line className={'w-4 h-4'} />},
    {id: 'authentication.sso', name: t('projects.options.SSO'), picto: <RiLoginBoxLine className={'w-4 h-4'} />},
    {id: 'authentication.googleConnect', name: t('projects.options.GoogleConnect'), picto: <RiGoogleFill className={'w-4 h-4'} />},
    {id: 'seo', name: t('projects.options.SEO'), picto: <RiSeoLine className={'w-4 h-4'} />},
    {id: 'geo', name: t('projects.options.GEO'), picto: <RiSeoLine className={'w-4 h-4'} />},
    {id: 'automation', name: t('projects.options.Automation-flows'), picto: <RiRobot2Line className={'w-4 h-4'} />},
    {id: 'beta.search', name: t('projects.options.Beta-search'), picto: <RiSearchLine className={'w-4 h-4'} />},
    {id: 'content.edit_publication_date', name: t('projects.options.Edit-publication-date'), picto: <RiCalendarEventFill className={'w-4 h-4'} />},
    {id: 'content.headers', name: t('projects.options.Manage-content-headers'), picto: <RiLayoutLine className={'w-4 h-4'} />},
    {id: 'content.exportPdf', name: t('projects.options.Export-content-as-pdf'), picto: <RiDownload2Line className={'w-4 h-4'} />},
    {id: 'views', name: t('projects.options.Count-Views'), picto: <RiEyeLine className={'w-4 h-4'} />},
    {id: 'gtm', name: t('projects.options.Google-tag-manager'), picto: <RiBarChartBoxLine className={'w-4 h-4'} />},
    {id: 'homepage.create', name: t('projects.options.Focus-page'), picto: <TbNorthStar className={'w-4 h-4'} />},
    {id: 'headers.manage', name: t('projects.options.Manage-headers'), picto: <RiLayoutTop2Line className={'w-4 h-4'} />},
    {id: 'menus.manage', name: t('projects.options.Manage-menus'), picto: <RiPlayListAddFill className={'w-4 h-4'} />},
    {id: 'import.import_content', name: t('projects.options.Import-content'), picto: <RiUpload2Line className={'w-4 h-4'} />},
    {id: 'import.import_structure', name: t('projects.options.Import-structures'), picto: <RiUpload2Line className={'w-4 h-4'} />},
    {id: 'import.import_attributes', name: t('projects.options.Import-attributes'), picto: <RiUpload2Line className={'w-4 h-4'} />},
    {id: 'sort.reference_date', name: t('projects.options.Reference-date'), picto: <RiListOrdered2 className={'w-4 h-4'} />},
    {id: 'sort.reference_date_setting', name: t('projects.options.Reference-date-setting'), picto: <RiCalendarEventFill className={'w-4 h-4'} />},
    {id: 'theme.custom_colors', name: t('projects.options.Custom-colors'), picto: <RiPencilRulerLine className={'w-4 h-4'} />}
  ];

  const getLastMepDate = () => {
    if (state?.last_app_build_requested_at || state?.last_backend_build_requested_at) {
      const mepDate = (state?.last_app_build_requested_at && state?.last_backend_build_requested_at) ?
        Math.max(state?.last_app_build_requested_at.toDate(), state?.last_backend_build_requested_at.toDate())
          : (state?.last_app_build_requested_at ?
            state?.last_app_build_requested_at.toDate()
              : state?.last_backend_build_requested_at.toDate());

      return moment(mepDate).format('DD/MM/YYYY - H:mm:ss');
    }

    return t('NC', {ns: 'dashboard'});
  }

  const refreshCredits = () => {
    if(!refreshCreditsLoading){
      setRefreshCreditsLoading(true);
      const refreshCreditsFunction = firebase.functions.httpsCallable("projects-refreshCredits");

      refreshCreditsFunction({
        project_id: state.id
      }).then((result) => {
        console.log('finish', result);
        setRefreshCreditsLoading(false);

        if(result.data?.success === true){
          dispatch(
            PlayNotifications({
              display: true,
              theme: 'success',
              message: t('success.success', {ns: 'messages'}),
            })
          );
        } else {
          dispatch(
            PlayNotifications({
              display: true,
              theme: 'danger',
              message: t('error.unknown-error-try-again-later', {ns: 'messages'}),
            })
          );
        }
      }).catch((error) => {
        setRefreshCreditsLoading(false);
        dispatch(
          PlayNotifications({
            display: true,
            theme: 'danger',
            message: t('error.unknown-error-try-again-later', {ns: 'messages'}),
          })
        )
        console.error(error);
      })
    }
  }

  const setOption = (option, activated) => {
    console.log('setOption')
    setFormLoading(true)
    // setEntityOptions
    const setEntityOptionsFunction = firebase.functions.httpsCallable("setEntityOptions");
    setEntityOptionsFunction({
      options: {
        [option]: activated
      },
      project_id: state.id
    }).then((result) => {
      console.log('success !!', result)
      setFormLoading(false)

      if(result.data?.success === true){
        firebase.db.collection('projects').doc(currentId).update({
          [`options.${option}`]: activated
        }).catch((e)=>{
          console.error('Error during update', e)
        })

        dispatch(
          PlayNotifications({
            display: true,
            theme: 'success',
            message: t('success.saved-changes', {ns: 'messages'}),
          })
        )
      } else {
        dispatch(
          PlayNotifications({
            display: true,
            theme: 'danger',
            message: t('error.unknown-error-try-again-later', {ns: 'messages'}),
          })
        )
      }
    }).catch((error) => {
      setFormLoading(false)
      dispatch(
        PlayNotifications({
          display: true,
          theme: 'danger',
          message: t('error.unknown-error-try-again-later', {ns: 'messages'}),
        })
      )
      console.error(error);
    });
  }

  const getOptionStatus = (option) => {
    return _.get(state, `options.${option}`) === true
  }

  const getOptionStatusTag = (option) => {
    if( _.get(state, `options.${option}`) === true ){
      return (
        <span className="cursor-pointer inline-flex gap-1 bg-green-100 border border-green-300 text-xs font-semibold text-green-600 inline rounded-full p-0.5 px-2">
          {t('status.Activated', {ns: 'dashboard'})}
        </span>
      )
    } else if (_.get(state, `options.${option}`) === false) {
      return (
        <span className="cursor-pointer inline-flex gap-1 bg-gray-100 border border-gray-300 text-xs font-semibold text-gray-600 inline rounded-full p-0.5 px-2">
          {t('status.Disabled', {ns: 'dashboard'})}
        </span>
      )
    } else if( _.get(state, `options.${option}`) === undefined ){
      return (
        <span className="cursor-pointer inline-flex gap-1 bg-red-100 border border-red-300 text-xs font-semibold text-red-600 inline rounded-full p-0.5 px-2">
          {t('status.Unset', {ns: 'dashboard'})}
        </span>
      )
    }

    return '-'
  }

  const closeForm = () => {
    setOpenChangePlan(false);
    setOpenChangeMode(false);
    setOpenDeploy(false);
    setOpenDeployFront(false);
    setOpenDeployTrialEnding(false);
    setOpenDeployRestoreFront(false);
    setOpenDeploySpecificBackend(false);
    setOpenDeployFullBackend(false);
    setOpenCreditsForm(false);
    setOpenAddCreditsForm(false);
  }

  useEffect(() => {
    document.title = `Memory - ${t('projects.Projects-management', {ns: 'dashboard'})}`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!currentId) return;
    setBuildsLoading(true);
    const unsub = firebase.db.collection('builds')
      .where('project_id', '==', currentId)
      .onSnapshot((snap) => {
        const builds = snap.docs
          .map(doc => ({...doc.data(), id: doc.id}))
          .sort((a, b) => {
            const aTime = a.created_at?.toDate?.()?.getTime() ?? 0;
            const bTime = b.created_at?.toDate?.()?.getTime() ?? 0;
            return bTime - aTime;
          })
          .slice(0, 15);
        setRecentBuilds(builds);
        setBuildsLoading(false);
      }, () => setBuildsLoading(false));
    return () => unsub();
  }, [currentId]);

  useEffect(() => {
    let projectSnapUnsubscribe;
    let entityRequestSnapUnsubscribe;

    if(currentId){
      projectSnapUnsubscribe = firebase.db.collection('projects').doc(currentId).onSnapshot( async projectDoc => {
        if (projectDoc.exists) {
          const projectData = {...projectDoc.data(), id: projectDoc.id}

          if(projectData.entity_request_id){
            entityRequestSnapUnsubscribe = firebase.db.collection('entity-request').doc(projectData.entity_request_id).onSnapshot( async doc => {
              if (doc.exists) {
                const data = {...doc.data(), id: doc.id}
                setEntityRequest(data);
              }
            })
          }

          setState(projectData);
          setReady(true);
        } else {
          setReady(true);
        }
      })
    }


    return () => {
      projectSnapUnsubscribe && projectSnapUnsubscribe();
      entityRequestSnapUnsubscribe && entityRequestSnapUnsubscribe();
    }
  }, [currentId])

  return (
    <>
      {openChangePlan &&
        <ChangePlanForm
          closeForm={() => closeForm()}
          project={state}
        />
      }
      {openChangeMode &&
        <ChangeModeForm
          closeForm={() => closeForm()}
          project={state}
        />
      }
      {openDeployFront &&
        <DeployFrontForm
          closeForm={() => closeForm()}
          project={state}
          type={'front'}
        />
      }
      {openDeploy &&
        <DeployFrontForm
          closeForm={() => closeForm()}
          project={state}
          type={'all'}
        />
      }
      {openDeployTrialEnding &&
        <DeployFrontForm
          closeForm={() => closeForm()}
          project={state}
          type={'trial'}
        />
      }
      {openDeployRestoreFront &&
        <DeployFrontForm
          closeForm={() => closeForm()}
          project={state}
          type={'restoreFront'}
        />
      }
      {openDeploySpecificBackend &&
        <DeployFrontForm
          closeForm={() => closeForm()}
          project={state}
          type={'specificBackend'}
        />
      }
      {openDeployFullBackend &&
        <DeployFrontForm
          closeForm={() => closeForm()}
          project={state}
          type={'fullBackend'}
        />
      }
      {openCreditsForm &&
        <CreditsForm
          closeForm={() => closeForm()}
          project={state}
          action={'update'}
        />
      }
      {openAddCreditsForm &&
        <CreditsForm
          closeForm={() => closeForm()}
          project={state}
          action={'add'}
        />
      }

      <LayoutDashboard
        currentUser={currentUser}
        // headerNav={SUB_NAV_SETTINGS}
        headerNavSelected={PROJECTS_MENU}
        selectedMenu={selectedMenu}
        maxHeight={false}
      >
        <div id="sections-container" className="flex flex-col justify-between w-full h-full max-w-100vw overflow-auto memoryScrollbar">
          <div className="flex flex-col relative">
            <header className="z-40 bg-white w-full pb-6 sticky top-0">
              <ul className="flex items-center justify-between mb-2">
                <li className="flex items-center gap-2">
                  <RiBuildingLine className="w-5 h-5 min-w-5"/>
                  <Headings
                    variant="h2"
                    className="flex items-center"
                    display="display-4"
                  >
                    {t('projects.Project', {ns: 'dashboard'})}: {state.name ? state.name : state.id}
                  </Headings>
                </li>
              </ul>
            </header>

            <div className="flex w-full relative">
              <div className="w-full pb-5 space-y-2">
                <div className={`flex flex-col w-full h-full pb-2 pr-4 pb-0 bg-white overflow-visible`}>

                  <div className={"flex justify-center mb-12"}>
                    <div className={"inline-flex bg-gray-100 rounded-full p-1 gap-1"}>
                      <button
                        onClick={() => setActiveTab('0')}
                        className={`px-6 py-2 rounded-full text-sm font-semibold transition-colors ${activeTab === '0' ? 'bg-white shadow text-gray-900' : 'text-gray-500 hover:text-gray-700'}`}
                      >
                        {t('projects.Informations', {ns: 'dashboard'})}
                      </button>
                      <button
                        onClick={() => setActiveTab('1')}
                        className={`px-6 py-2 rounded-full text-sm font-semibold transition-colors ${activeTab === '1' ? 'bg-white shadow text-gray-900' : 'text-gray-500 hover:text-gray-700'}`}
                      >
                        {t('projects.Deployments', {ns: 'dashboard'})}
                      </button>
                    </div>
                  </div>

                  <CustomTabPanel value={activeTab} index={0}>
                  <div className={`mb-4 text-xl font-semibold`}>
                    {t('projects.Informations', {ns: 'dashboard'})}
                  </div>
                  <div className={`flex flex-col gap-4`}>
                    <div className={"grid grid-cols-1 md:grid-cols-2"}>
                      <div className={`flex flex-col gap-1`}>
                        <span className={``}>{t('Name', {ns: 'common'})}</span>
                        <span className={`font-semibold`}>{state.name ? state.name : t('NC', {ns: 'dashboard'})}</span>
                      </div>

                      <div className={`flex flex-col gap-1`}>
                        <span className={``}>{t('projects.Domain-subdomain', {ns: 'dashboard'})}</span>
                        <span className={`font-semibold`}>
                          <a target="_blank" rel="noopener noreferrer" className={"text-blue-600 hover:underline"} href={state.domain ? state.domain : state.subdomain ? state.subdomain : "#"}>{state.domain ? state.domain : state.subdomain ? state.subdomain : t('NC', {ns: 'dashboard'})}</a>
                        </span>
                      </div>
                    </div>

                    <div className={`flex flex-col gap-1`}>
                      <span className={``}>{t('projects.Request-email', {ns: 'dashboard'})}</span>
                      <span className={`font-semibold`}>{entityRequest?.email ? entityRequest?.email : t('NC', {ns: 'dashboard'})}</span>
                    </div>

                    <div className={"border-t border-gray-300 my-2"}></div>

                    <div className={"grid grid-cols-1 md:grid-cols-3"}>
                      <div className={`flex flex-col gap-1`}>
                        <span className={``}>{t('Plan', {ns: 'common'})}</span>
                        <span
                          className={`font-semibold`}>{state.plan ? t(capitalizeFirstLetter(state.plan), {ns: 'common'}) : t('NC', {ns: 'dashboard'})}</span>
                        {(state.plan === 'custom' && state.custom_plan) &&
                          <span className={`text-sm text-gray-600`}>
                            {t('projects.custom-plan-summary', {
                              ns: 'dashboard',
                              credits: state.custom_plan.credits,
                              renewal: state.custom_plan.monthly_renewal ? t('projects.custom-plan-renewed', {ns: 'dashboard'}) : t('projects.custom-plan-not-renewed', {ns: 'dashboard'}),
                            })}
                          </span>
                        }
                        <span
                          className={`w-fit cursor-pointer text-sm text-gray-600 hover:underline`}
                          onClick={() => setOpenChangePlan(true)}
                        >
                          {t('projects.Change-plan', {ns: 'dashboard'})}
                        </span>
                      </div>

                      <div className={`flex flex-col gap-1`}>
                        <span className={``}>{t('Mode', {ns: 'common'})}</span>
                        <span
                          className={`font-semibold`}>{state.mode ? t(capitalizeFirstLetter(state.mode), {ns: 'common'}) : t('NC', {ns: 'dashboard'})}</span>
                        <span
                          className={`w-fit cursor-pointer text-sm text-gray-600 hover:underline`}
                          onClick={() => setOpenChangeMode(true)}
                        >
                          {t('projects.Change-mode', {ns: 'dashboard'})}
                        </span>
                      </div>

                      <div className={`flex flex-col gap-1`}>
                        <span className={`flex gap-2 items-center`}>
                          {t('Credits', {ns: 'common'})}
                          <span
                            className={`cursor-pointer rounded-full bg-white hover:bg-gray-200 p-1 w-fit animate ${refreshCreditsLoading ? 'animate-spin' : ''}`}
                            onClick={() => refreshCredits()}
                          >
                            <RiRefreshLine className={`w-4 h-4`} />
                          </span>
                        </span>
                        <span className={`flex gap-2 items-center`}>
                          <span className={`font-semibold px-2 py-1 bg-gray-100 rounded`}>{typeof state.current_credits !== undefined ? state.current_credits : t('NC', {ns: 'dashboard'})}</span>
                          <span className={`flex gap-1 items-center`}>
                            <span
                              className={`cursor-pointer rounded-full bg-white hover:bg-gray-200 p-1 w-fit`}
                              onClick={() => setOpenCreditsForm(true)}
                            >
                              <RiPencilLine className={`w-4 h-4`} />
                            </span>
                            <span
                              className={`cursor-pointer rounded-full bg-white hover:bg-gray-200 p-1 w-fit`}
                              onClick={() => setOpenAddCreditsForm(true)}
                            >
                              <RiAddLine className={`w-4 h-4`} />
                            </span>
                          </span>
                        </span>
                      </div>
                    </div>

                    <div className={"border-t border-gray-300 my-2"}></div>

                    <div className={"grid grid-cols-1 md:grid-cols-3"}>
                      <div className={`flex flex-col gap-1`}>
                        <span className={``}>{t('date.Creation-date', {ns: 'common'})}</span>
                        <span className={`font-semibold`}>{state.created_at ? moment(state.created_at.toDate()).format('DD/MM/YYYY - H:mm:ss') : t('NC', {ns: 'dashboard'})}</span>
                      </div>

                      <div className={`flex flex-col gap-1`}>
                        <span className={``}>{t('projects.Current-branch', {ns: 'dashboard'})}</span>
                        <span className={`font-semibold`}>{state?.current_branch ? state.current_branch : t('NC', {ns: 'dashboard'})}</span>
                      </div>

                      <div className={`flex flex-col gap-1`}>
                        <span className={``}>{t('projects.Last-mep-date', {ns: 'dashboard'})}</span>
                        <span className={`font-semibold`}>
                          {getLastMepDate()}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className={`mt-16 mb-4 text-xl font-semibold`}>
                    {t('projects.Set-options', {ns: 'dashboard'})}
                  </div>
                  <div className={`flex flex-col gap-2`}>
                    {availableOptions.map((option, index) => (
                      <div key={index} className={`flex py-2 px-4 gap-4 hover:bg-gray-100 items-center justify-between`}>
                        <div className={`flex gap-4 items-center`}>
                          <span className={`inline-flex gap-2 items-center`}>
                            {option.picto && option.picto}
                            {t(option.name, {ns: 'dashboard'})}
                          </span>
                          <span>
                            {getOptionStatusTag(option.id)}
                          </span>
                        </div>

                        <div className={``}>
                          <button
                            onClick={() => setOption(option.id, !getOptionStatus(option.id) === true)}
                            className={`flex items-center gap-x-2 border px-2 py-1 rounded cursor-pointer text-sm bg-white ${formLoading ? 'opacity-50' : 'opacity-100'}`}
                            disabled={formLoading}
                          >
                            {formLoading && <RiLoader4Line className="w-4 h-4 animate-spin"/>}
                            {getOptionStatus(option.id) === true ?
                              t('action.Disable', {ns: 'common'})
                              :
                              t('action.Enable', {ns: 'common'})
                            }
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                  </CustomTabPanel>

                  <CustomTabPanel value={activeTab} index={1}>
                    <div className={"grid grid-cols-1 md:grid-cols-2 gap-4"}>
                      <div className={`flex flex-col gap-1`}>
                        <span className={``}>{t('date.Creation-date', {ns: 'common'})}</span>
                        <span className={`font-semibold`}>{state.created_at ? moment(state.created_at.toDate()).format('DD/MM/YYYY - H:mm:ss') : t('NC', {ns: 'dashboard'})}</span>
                      </div>

                      <div className={`flex flex-col gap-1`}>
                        <span className={``}>{t('projects.Last-mep-date', {ns: 'dashboard'})}</span>
                        <span className={`font-semibold`}>
                          {getLastMepDate()}
                        </span>
                      </div>

                      <div className={`flex flex-col gap-1`}>
                        <span className={``}>{t('projects.Current-branch', {ns: 'dashboard'})}</span>
                        <span className={`font-semibold`}>{state?.current_branch ? state.current_branch : t('NC', {ns: 'dashboard'})}</span>
                      </div>

                      <div className={`flex flex-col gap-1`}>
                        <span className={``}>{t('projects.Commit-sha', {ns: 'dashboard', defaultValue: 'Commit SHA'})}</span>
                        <span className={`font-semibold font-mono truncate`}>{state?.last_backend_build_id ? state.last_backend_build_id : t('NC', {ns: 'dashboard'})}</span>
                      </div>
                    </div>

                  <div className={`mt-16 mb-4 text-xl font-semibold`}>
                    {t('projects.Deployments', {ns: 'dashboard'})}

                    <div className={"text-sm font-normal"}>
                      <span>
                        {t("projects.prerenderVersion", {ns: "dashboard", defaultValue: "Version de la fonction de pré rendu : "})}
                      </span>
                      <span className={"font-semibold"}>
                        {state.prerenderVersion === "2" ? t("projects.prerenderVersion-gen2", {ns: "dashboard", defaultValue: "2nd génération"}) : t("projects.prerenderVersion-gen2", {ns: "dashboard", defaultValue: "1ère génération"})}
                      </span>
                    </div>
                  </div>
                  <div className={"grid grid-cols-1 md:grid-cols-4 gap-4"}>
                    <div
                      className={`flex flex-col gap-2 px-4 py-2 border border-gray-300 rounded items-center justify-center text-center cursor-pointer hover:bg-gray-100`}
                      onClick={() => setOpenDeployFront(true)}
                    >
                      <span
                        className={`w-fit cursor-pointer text-base text-gray-600`}
                      >
                        {t('projects.Deploy-frontend', {ns: 'dashboard'})}
                      </span>
                    </div>

                    <div
                      className={`flex flex-col gap-2 px-4 py-2 border border-gray-300 rounded items-center justify-center text-center cursor-pointer hover:bg-gray-100`}
                      onClick={() => setOpenDeploy(true)}
                    >
                      <span
                        className={`w-fit cursor-pointer text-base text-gray-600`}
                      >
                        {t('projects.Deploy', {ns: 'dashboard'})}
                      </span>
                    </div>

                    <div
                      className={`flex flex-col gap-2 px-4 py-2 border border-gray-300 rounded items-center justify-center text-center cursor-pointer hover:bg-gray-100`}
                      onClick={() => setOpenDeployTrialEnding(true)}
                    >
                      <span
                        className={`w-fit cursor-pointer text-base text-gray-600`}
                      >
                        {t('projects.Deploy-trial-ending', {ns: 'dashboard'})}
                      </span>
                    </div>

                    <div
                      className={`flex flex-col gap-2 px-4 py-2 border border-gray-300 rounded items-center justify-center text-center`}
                      onClick={() => setOpenDeployRestoreFront(true)}
                    >
                      <span
                        className={`w-fit cursor-pointer text-base text-gray-600`}
                      >
                        {t('projects.Deploy-frontend-restore', {ns: 'dashboard'})}
                      </span>
                    </div>

                    <div
                      className={`flex flex-col gap-2 px-4 py-2 border border-gray-300 rounded items-center justify-center text-center cursor-pointer hover:bg-gray-100`}
                      onClick={() => setOpenDeploySpecificBackend(true)}
                    >
                      <span
                        className={`w-fit cursor-pointer text-base text-gray-600`}
                      >
                        {t('projects.Deploy-specific-backend', {ns: 'dashboard', defaultValue: 'Déployer des fonctions spécifiques'})}
                      </span>
                    </div>

                    <div
                      className={`flex flex-col gap-2 px-4 py-2 border border-gray-300 rounded items-center justify-center text-center cursor-pointer hover:bg-gray-100`}
                      onClick={() => setOpenDeployFullBackend(true)}
                    >
                      <span
                        className={`w-fit cursor-pointer text-base text-gray-600`}
                      >
                        {t('projects.Deploy-full-backend', {ns: 'dashboard', defaultValue: 'Relancer tout le backend'})}
                      </span>
                    </div>
                  </div>

                  <div className={`mt-16 mb-4 text-xl font-semibold`}>
                    {t('projects.Recent-deployments', {ns: 'dashboard', defaultValue: 'Déploiements récents'})}
                  </div>
                  {buildsLoading ? (
                    <div className="flex items-center gap-2 text-sm text-gray-400">
                      <RiLoader4Line className="w-4 h-4 animate-spin" />
                      <span>Chargement...</span>
                    </div>
                  ) : recentBuilds.length === 0 ? (
                    <div className="text-sm text-gray-400">Aucun déploiement enregistré.</div>
                  ) : (
                    <div className="flex flex-col divide-y divide-gray-100 border border-gray-200 rounded">
                      {recentBuilds.map((build) => {
                        const statusStyles = {
                          SUCCESS:   'bg-green-100 text-green-700 border-green-300',
                          FAILURE:   'bg-red-100 text-red-700 border-red-300',
                          WORKING:   'bg-blue-100 text-blue-700 border-blue-300',
                          QUEUED:    'bg-gray-100 text-gray-500 border-gray-300',
                          REQUESTED: 'bg-gray-100 text-gray-500 border-gray-300',
                          PENDING:   'bg-gray-100 text-gray-500 border-gray-300',
                          CANCELLED: 'bg-gray-100 text-gray-400 border-gray-200',
                        };
                        const statusClass = statusStyles[build.status] ?? 'bg-gray-100 text-gray-400 border-gray-200';
                        const isLive = ['WORKING', 'QUEUED', 'REQUESTED', 'PENDING'].includes(build.status);
                        const groupLabel = build.subtype
                          ? build.subtype.replace('deploy-functions-', '')
                          : (build.type ?? build.id);
                        const buildDate = build.created_at?.toDate
                          ? moment(build.created_at.toDate()).format('DD/MM HH:mm:ss')
                          : build.created_on ? moment(build.created_on).format('DD/MM HH:mm:ss') : '';

                        return (
                          <div key={build.id} className="flex items-center justify-between py-2 px-3 hover:bg-gray-50">
                            <div className="flex items-center gap-3 min-w-0">
                              <span className={`inline-flex items-center gap-1 text-xs border rounded-full px-2 py-0.5 font-medium shrink-0 ${statusClass}`}>
                                {isLive && <span className="w-1.5 h-1.5 rounded-full bg-current animate-pulse" />}
                                {build.status ?? '—'}
                              </span>
                              <span className="text-sm font-mono truncate">{groupLabel}</span>
                              <span className="text-xs text-gray-400 shrink-0">
                                {build.deploy_source === 'gitlab' ? 'GitLab CI' : build.deploy_source === 'cloudbuild' ? 'Cloud Build' : ''}
                              </span>
                            </div>
                            <div className="flex items-center gap-3 shrink-0 ml-2">
                              <span className="text-xs text-gray-400">{buildDate}</span>
                              {build.gitlab_web_url && (
                                <a
                                  href={build.gitlab_web_url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-blue-500 hover:text-blue-700"
                                  title="Voir la pipeline GitLab"
                                >
                                  <RiExternalLinkLine className="w-4 h-4" />
                                </a>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}

                  </CustomTabPanel>

                </div>
              </div>
            </div>
          </div>

          <div
            className="z-50 flex shrink-0 items-center mt-2 border-t-2 border-gray-400 bg-gray-100 justify-between pb-6 pt-6 px-4 space-x-2 sticky bottom-0">
            <Button
              actionType="route"
              action="/dashboard/projects/projects"
              theme={formLoading ? 'disabled' : 'simple'}
              size="small"
              icon={<RiArrowLeftLine className="mr-1"/>}
            >
              {t('action.Back')}
            </Button>
          </div>
        </div>
      </LayoutDashboard>
    </>
  )
}

export default ProjectPage

const CustomTabPanel = ({children, value, index}) => {
  return (
    <div
      role="tabpanel"
      hidden={parseInt(value) !== index}
      id={`project-tabpanel-${index}`}
      aria-labelledby={`project-tab-${index}`}
    >
      {parseInt(value) === index && children}
    </div>
  );
}